import * as types from '../actions/types';
import * as deleteAccountUsers from 'store/actions/accounts/users/deleteAccountUsers';
import * as fetchAccountUsers from '../actions/accounts/users/fetchAccountUsers';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* fetchAccountUsersAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/current-account/users`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchAccountUsers.fetchAccountUsersSuccess(response));
    } catch (error) {
        yield put(fetchAccountUsers.fetchAccountUsersFailure(error));
    }
}

function* deleteAccountUserAsync({ payload }) {
    const {
        id,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/current-account/users/${ id }`;

        yield apiClient.delete(url);

        yield put(deleteAccountUsers.deleteAccountUsersSuccess(payload));
    } catch (error) {
        yield put(deleteAccountUsers.deleteAccountUsersFailure(error));
    }
}

function *deleteAccountUserSuccessAsync() {
    yield put(showNotification('notifications.current_account.delete.success', 'success'));
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* accountUsersSagas() {
    yield [
        takeEvery(types.FETCH_ACCOUNT_USERS, fetchAccountUsersAsync),
        takeEvery(types.FETCH_ACCOUNT_USERS_FAILURE, failureMessage),

        takeEvery(types.DELETE_ACCOUNT_USERS, deleteAccountUserAsync),
        takeEvery(types.DELETE_ACCOUNT_USERS_FAILURE, failureMessage),
        takeEvery(types.DELETE_ACCOUNT_USERS_SUCCESS, deleteAccountUserSuccessAsync),
    ];
}


// WEBPACK FOOTER //
// ./src/store/sagas/accountUsersSagas.js